import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Location from "./Location";
import Transaction from "./Transaction";
import Card from "./Card";
import Modal from './Modal'
import { calculateMaterialsDowntheLine, calculatePartnersDowntheLine } from "./utility/utils";

function Step(props) {
  const [modal, setModal] = useState(false)
  const [modalContent, setModalContent] = useState(false)
  const [open, setOpen] = useState(false);
  const { step, loadMore, steps } = props;
  if (!step.id) return null;
  const renderStepHeader = () => {
    const { status, refImage, name } = step;
    return (
      <div className="d-flex pb-3">
        <div className="stepImage">
          <img
            src={refImage}
            alt={name}
            width="100%"
            className="customShadow customRadius"
          />
        </div>
        <div
          className={`stepHeader customRadius ${!step.status ? "inactive":""} ${
            status ? "" : "inactive customRadius"
          }`}
          onClick={() => setOpen(!open)}
        >
          <div className="underStepHeader">
            <h4>{step.refMaterialsOut[0]?.name}</h4>

            {open ? (
              <FontAwesomeIcon icon={faChevronUp} />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} />
            )}
          </div>
          <h1>{name}</h1>
        </div>
      </div>
    );
  };

  const renderStepDescription = () => {
    const { refDescription, refPartner } = step;
    return (
      <blockquote className="blockquote px-2 border-left">
        <h5 className="text-secondary">
          <h2>Description - </h2>
          {refDescription}
        </h5>
        <h5 className="text-secondary">
          <h2>Partner - </h2>
          {refPartner.map((item) => item.username)}
        </h5>
      </blockquote>
    );
  };

  const renderTransaction = () => {
    return <Transaction step={step} />;
  };

  const renderStepContent = () => {
    var materialsCount = calculateMaterialsDowntheLine(step.id, steps);

    
    var partnersCount = calculatePartnersDowntheLine(step.id, steps);

    if (open) {
      return (
        <div className="stepBody">
          {renderStepDescription()}
          <ul className="beigeList d-flex p-0 border-0 mt-0 m-0">
            <Location step={step} />
            {renderTransaction()}
          </ul>
          {renderStepImpactCriterias()}
          <Card
            materialsCount={materialsCount}
            partnersCount={partnersCount}
            name={step.refMaterialsOut[0]?.name}
          />
          {renderDiscoverJourney()}
        </div>
      );
    }
  };
  const renderDiscoverJourney = () => {
    const hashChildren =
      steps.filter((o) => o.end.includes(step.id)).length > 0;

    return (
      hashChildren && (
        <div onClick={() => loadMore(step)} className="discoverjourney">
          <h1>
            DISCOVER THE JOURNEY OF {step.refMaterialsOut[0]?.name} {step.id}
          </h1>
        </div>
      )
    );
  };

  const renderStepImpactCriterias = () => {
    const { refImpactCriterias } = step;
    if (refImpactCriterias && refImpactCriterias.length > 0) {
      const html = refImpactCriterias.map(
        (criteria, i) => (
          <>
            {criteria.refImage ? (
              <img
                key={i}
                onClick={() => { setModal(!modal); setModalContent(criteria.description) } }
                className=" materialImage impactImage mb-2"
                src={criteria.refImage}
                alt={criteria.name}
              />
            ) : null}
          </>
        )
      );

      return (
        <div className="impactCriterias">
          <h1 className="impactCriteriaTittle p-1">IMPACT CRITERIAS</h1>
          <ul className="list-unstyled p-0">{html}</ul>
        </div>
      );
    }
  };

  return (
    <div className="step">
      <div className={`stepCount ${!step.status ? "inactive":""}`}>
        <div className="stepCountInner">{/* {no} */}</div>
      </div>
      {renderStepHeader()}
      <div className="stepContent">{renderStepContent()}</div>
      {modal && <Modal title="Impact Criteria" modal={modal} toggleModal={setModal}>
        <p className="p-2">{modalContent}</p>
      </Modal>}
    </div>
  );
}

export default Step;
